<template>
    <div>
        <div class="ranking-container">
            <div class="d-flex start mb-2">
                <el-date-picker
                    v-model="month"
                    type="month"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    style=" border: none"
                >
                </el-date-picker>
            </div>
            <div>
                <el-row :gutter="20">
                    <el-col
                        v-for="(board, index) in boards"
                        :key="index"
                        :xs="24" :sm="12" :md="12" :lg="6" :xl="6"
                    >
                        <div
                            class="card p-3 rounded bg-light"
                            v-if="board.permission.includes(keyAccount) && board.users.length > 0"
                        >
                            <h5 class="font-weight-bold mb-3">Bảng xếp hạng {{ board.title }}</h5>
                            <div
                                v-for="(user, i) in board.users"
                                :key="i"
                                class="d-flex align-items-center justify-content-between mb-2 p-2 bg-white rounded shadow-sm"
                            >
                                <div class="d-flex align-items-center">
                                    <img :src="user.avatar || '/media/default-avatar.png'" class="rounded-circle mr-2" style="width: 36px; height: 36px" alt="avatar" />
                                    <div>

                                        <p style="font-size: 13px;" class="mb-0 font-weight-bold">{{ user.name }} <img class="ml-2" v-if="i == 0"  width="25px" style="margin-top: -9px" src="/media/crown.gif" alt=""></p>

                                        <small style="font-size: 12px">
                                            Doanh số:
                                            <span class="text-bold">{{
                                                    board.key == 'sales'
                                                        ? Number(user.total_personal).toLocaleString('vi-VN')
                                                        : Number(user.total_revenue).toLocaleString('vi-VN')
                                                }}
                                            </span>
                                        </small>
                                    </div>
                                </div>
                                <div class="rounded-pill text-white" style="background-color: #059669;">
                                    <span class="p-2 " v-if="i <= 2 " size="mini" type="success">Top {{ i + 1 }}</span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>

  </template>

  <script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {GET_LEADER_BOARD_SALE} from "@/core/services/store/report.module";
import {mapGetters} from "vuex";
import {
    ROLE_SALES_123,
    ROLE_SALES_45,
    ROLE_SALES_LEAD,
    ROLE_DIRECTOR,
    ROLE_AREA,
    ROLE_REGION,
    ROLE_BOD
} from "@/core/config/accountTypeOption";
  export default {
    name: 'RankingBoards',
    data() {
      return {
        currentRole: 'admin',
        month: this.$moment().format('YYYY-MM'),
        boards: [
          {
            key: 'sales',
            title: 'Sales',
            permission: [ROLE_SALES_123, ROLE_SALES_45,ROLE_SALES_LEAD,ROLE_DIRECTOR,ROLE_AREA,ROLE_REGION,ROLE_BOD],
            users: []
          },
          {
            key: 'sales45',
            title: 'Sales 4,5',
            permission: [ROLE_SALES_45,ROLE_SALES_LEAD,ROLE_DIRECTOR,ROLE_AREA,ROLE_REGION,ROLE_BOD],
            users: []
          },
          {
            key: 'sl',
            title: 'SL',
            permission: [ROLE_SALES_LEAD,ROLE_DIRECTOR,ROLE_AREA,ROLE_REGION,ROLE_BOD],
            users: []
          },
          {
            key: 'gdvp',
            title: 'GDVP',
            permission: [ROLE_DIRECTOR,ROLE_AREA,ROLE_REGION,ROLE_BOD],
            users: []
          }
        ]
      };
    },

    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Bảng xếp hạng", icon: "fal fa-chart-area" },
        ]);
        this.getSale();
        this.getSale45(2);
        this.getSaleLeader(3);
        this.getSaleDirector(4);
    },

    watch: {
      month: {
        handler(newVal, oldVal) {
          if (newVal !== oldVal) {
              this.getSale();
              this.getSale45();
              this.getSaleLeader();
              this.getSaleDirector();
          }
        }
      }
    },
    methods: {
      getSale() {
        const payload = {
            date : this.month,
            role: 1
        }
        this.$store.dispatch(GET_LEADER_BOARD_SALE, payload).then((res) => {
          if (res) {
            this.boards[0].users = res.data;
          }
        });
      },

      getSale45() {
          const payload = {
              date : this.month,
              role: 2
          }
        this.$store.dispatch(GET_LEADER_BOARD_SALE, payload).then((res) => {
          if (res) {
            this.boards[1].users = res.data;

          }
        });
      },

      getSaleLeader() {
          const payload = {
              date : this.month,
              role: 3
          }
        this.$store.dispatch(GET_LEADER_BOARD_SALE, payload).then((res) => {
          if (res) {
            this.boards[2].users = res.data;
          }
        });
      },

        getSaleDirector() {
        const payload = {
            date : this.month,
            role: 4
        }
        this.$store.dispatch(GET_LEADER_BOARD_SALE, payload).then((res) => {
            if (res) {
                this.boards[3].users = res.data;
            }
        });
      },
    },
      computed: {
          ...mapGetters(["currentUser", "keyAccount", "isShowMonthDash"]),
      },
  };
  </script>

  <style scoped>
  .ranking-container {
    padding: 20px;
  }
  </style>
